<template>
    <accordion ref="accordion">
        <div class="tabs">
            <slot name="nav">
                <tab-nav />
            </slot>

            <div class="tab__panels">
                <slot />
            </div>
        </div>
    </accordion>
</template>

<script setup>
    import { provide, ref } from 'vue';
    import Accordion from '@app/components/accordion/Refactored/Accordion.vue';
    import TabNav from './TabNav.vue';

    const accordion = ref(null)

    const tabs = ref({})

    provide('tabs', {
        tabs      : tabs,
        addTab    : (id, title) => tabs.value[id] = title,
        removeTab : (id) => delete tabs.value[id],
        accordion : accordion
    })
</script>